import { z } from 'zod'
import typeguard from 'src/shared/typeguard'


export const apiResponseSchema = z.object({
  response: z.unknown(),
  error: z.string().optional(),
})
export type apiResponse = z.infer<typeof apiResponseSchema>
export const isApiResponse = typeguard<apiResponse>(apiResponseSchema)